<div class="tw-flex tw-flex-col tw-gap-3 tw-py-2">
    @for (item of items(); track item.method.id) {
        <form #form="ngForm" class="tw-border tw-border-solid tw-border-[var(--sys-divider)] tw-rounded-xl tw-overflow-hidden" autocomplete="off">
            <div class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-cursor-pointer" (click)="toggle(item, form)">
                <mat-icon class="tw-text-[var(--sys-secondary-text)]">{{ typeIcon(item) }}</mat-icon>
                <div class="tw-flex tw-flex-col tw-min-w-0 tw-flex-1">
                    <span class="tw-font-medium tw-truncate">{{ item.method.name }}</span>
                    <span class="tw-text-xs tw-text-[var(--sys-secondary-text)] tw-truncate">{{ typeName(item) }}</span>
                </div>
                @if (!item.isNew) {
                    <mat-icon>{{ item.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                }
            </div>

            @if (item.expanded) {
                <div class="tw-flex tw-flex-col tw-gap-1 tw-p-3 tw-pt-0">
                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.PAYMENT_NAME' | translate }}</mat-label>
                        <input matInput name="name" [(ngModel)]="item.method.name" required maxlength="30" [pattern]="namePattern" />
                        <mat-hint>{{ 'SETTINGS.SETTINGS.MAX_30' | translate }}</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.TYPE' | translate }}</mat-label>
                        <mat-select panelClass="settings-select-panel" name="type" [(ngModel)]="item.method.payment_method_type_id" required (selectionChange)="onTypeChange(item)">
                            @for (type of types; track type.id) {
                                <mat-option [value]="type.id">{{ type.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.BUNDLE_NAME' | translate }}</mat-label>
                        <input matInput name="bundle_name" [(ngModel)]="item.method.bundle_name" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.SCHEMA_NAME' | translate }}</mat-label>
                        <input matInput name="schema_name" [(ngModel)]="item.method.schema_name" />
                    </mat-form-field>

                    @for (field of configurationFields(item); track field.id) {
                        @if (field.type === 'boolean') {
                            <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-3">
                                <span class="tw-font-medium">{{ field.name | translate }}</span>
                                <mat-slide-toggle [name]="'configuration_' + field.id" [aria-label]="field.name | translate" [(ngModel)]="item.method.configuration[field.id]" />
                            </div>
                            <mat-divider />
                        } @else {
                            <mat-form-field appearance="outline" class="tw-w-full">
                                <mat-label>{{ field.name | translate }}</mat-label>
                                <input matInput [name]="'configuration_' + field.id" [(ngModel)]="item.method.configuration[field.id]" />
                            </mat-form-field>
                        }
                    }

                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.OVERRIDE_PRINTER' | translate }}</mat-label>
                        <mat-select panelClass="settings-select-panel" name="override_printer" [(ngModel)]="item.overridePrinter" [compareWith]="isSamePrinter" (selectionChange)="onPrinterChange(item)">
                            @for (printer of documentPrinters; track printer.id) {
                                <mat-option [value]="printer">{{ printer.name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.OVERRIDE_DOCUMENT' | translate }}</mat-label>
                        <mat-select panelClass="settings-select-panel" name="override_document" [(ngModel)]="item.overrideDocument" [compareWith]="isSameDocument">
                            <mat-option [value]="null">{{ 'SETTINGS.SETTINGS.OVERRIDE_DOCUMENT_NONE' | translate }}</mat-option>
                            @for (document of item.overridePrinter?.availableDocuments; track $index) {
                                <mat-option [value]="document">{{ documentName(document) }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.COLOR' | translate }}</mat-label>
                        <mat-select panelClass="settings-select-panel" name="color" [(ngModel)]="item.method.color">
                            @for (color of colors; track color.value) {
                                <mat-option [value]="color.value" [style.background-color]="color.value ? '#' + color.value : null">{{ color.name | translate }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="tw-w-full">
                        <mat-label>{{ 'SETTINGS.SETTINGS.PAYMENT_CONDITIONS' | translate }}</mat-label>
                        <mat-select panelClass="settings-select-panel" name="payment_condition" [(ngModel)]="item.method.payment_condition_id">
                            @for (condition of paymentConditions(); track condition.value) {
                                <mat-option [value]="condition.value">
                                    {{ condition.value === null ? (condition.name | translate) : condition.name }}
                                    @if (!isMagoEnabled && condition.value !== null) {
                                        <button mat-icon-button type="button" class="tw-ml-auto" (click)="$event.stopPropagation(); editPaymentCondition(item, condition.value)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    }
                                </mat-option>
                            }
                            @if (!isMagoEnabled) {
                                <mat-option (click)="addPaymentCondition()">{{ 'SETTINGS.SETTINGS.ADD_PAYMENT_CONDITION' | translate }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @for (toggle of toggles; track toggle.name) {
                        <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-3">
                            <span class="tw-font-medium">{{ toggle.label | translate }}</span>
                            <mat-slide-toggle [name]="toggle.name" [aria-label]="toggle.label | translate" [(ngModel)]="item.method[toggle.name]" />
                        </div>
                        @if (!$last) {
                            <mat-divider />
                        }
                    }

                    <div class="tw-flex tw-justify-start tw-gap-2 tw-pt-2">
                        <app-action-btn [disabled]="!!form.invalid" (click)="save(item, form)">{{ 'SETTINGS.SETTINGS.SAVE' | translate }}</app-action-btn>
                        @if (canResetConfiguration && hasConfiguration(item)) {
                            <app-action-btn variant="basic" (click)="resetConfiguration(item, form)">{{ 'SETTINGS.SETTINGS.RESET' | translate }}</app-action-btn>
                        }
                        <app-action-btn variant="basic" color="warn" (click)="remove(item)">{{ 'SETTINGS.SETTINGS.DELETE' | translate }}</app-action-btn>
                    </div>
                </div>
            }
        </form>
    }

    @if (canAddPaymentMethod) {
        <div class="tw-flex tw-justify-end">
            <app-action-btn variant="stroked" (click)="addPaymentMethod()">
                <mat-icon>add</mat-icon>
                {{ 'SETTINGS.HUB.ACTIONS.ADD_PAYMENT_METHOD' | translate }}
            </app-action-btn>
        </div>
    }
</div>
